import { axiosV1 } from 'interceptors/axios';

import { decryptResponse } from 'utils/token';

type GetRecipientsInfoProps = {
  communicationId: string;
  signal?: AbortSignal;
};

export const getRecipientsInfo = async ({
  communicationId,
  signal,
}: GetRecipientsInfoProps) => {
  const { data } = await axiosV1.get(`/comms/recipients/${communicationId}`);

  const decodedData = await decryptResponse(data);

  return decodedData;
};
